<template>
	<div class="vh100 bgfff pt20 plr20 bf" style="box-sizing: border-box;">
		<div class="">
			<div class="page_title mb20">项目信息</div>
			<div class="flex_items flex pl15 mb10">
				<div class="ca6 mr20">项目名称</div>
				<div class="">{{msg.project ? msg.project.name : ''}}</div>
			</div>
			<!-- <div class="flex_items flex pl15">
				<div class="ca6 mr20">活动时间</div>
				<div class="">{{msg.project.updated_at}}</div>
			</div> -->
		</div>
		<div class="sign" style="margin-top: 150px;">
			<div class="bc flex flex_items flex_center" style="margin: 0 auto;"
				:class="status == 0 ? 'b' : status == 1 ? 'g' : 'h'" @click="sign('forenoon',status)" v-if="status == 0 || status == 1">
				<div class="circle flex_center flex_column">
					<div class="mb10">上午</div>
					<div class="">{{statusName}}</div>
					<!-- <div class="" v-if="status == 2">{{timer}}</div> -->
				</div>
			</div>
			
			<div class="bc flex flex_items flex_center" style="margin: 0 auto;margin-top: 20px;"  v-if="status1 == 0 || status1 == 1"
				:class="status1 == 0 ? 'b' : status1 == 1 ? 'g' : 'h'" @click="sign('afternoon',status1)">
				<div class="circle flex_center flex_column">
					<div class="mb10">下午</div>
					<div class="">{{statusName1}}</div>
					<!-- <div class="" v-if="status == 2">{{timer}}</div> -->
				</div>
			</div>
			<div class="bc flex flex_items flex_center h" style="margin: 0 auto;margin-top: 20px;"  v-if="status1 != 0 && status1 != 1 && status != 0 && status != 1">
				<div class="circle flex_center flex_column">
					<div class="">今日无需签到</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				msg: {},
				timer: '17:20:30',
				id: '',
				status: 99,
				status1: 99,
				statusName: '',
				statusName1: '',
				timerFn: null,
				startT: '', //签到开始时间
				endT: '', //签到结束时间
			}
		},
		methods: {
			getList() {
				this.api.signView({}, this.id).then(res => {
					this.status = res.data.forenoon;
					this.status1 = res.data.afternoon;
					this.msg = res.data;
					this.statusName = this.getStatus(this.status);
					this.statusName1 = this.getStatus(this.status1);
					// if (rs == 1) {
					// 	this.status = 1;
					// } else if (rs == 0) {
					// 	let d = new Date();
					// 	let nowDay = d.getFullYear() + '/' + (d.getMonth() + 1) + '/' + d.getDate();
					// 	let st = nowDay + ' ' + (res.data.plan.time_start ? res.data.plan.time_start : '00:00:00');
					// 	let et = nowDay + ' ' + (res.data.plan.time_end ? res.data.plan.time_end : '23:59:59');
					// 	this.startT = new Date(st).getTime();
					// 	this.endT = new Date(et).getTime();
					// 	this.setTimer()
					// } else {
					// 	this.status = 0;
					// }
				})
			},
			getStatus(t) {
				let d;
				switch (t) {
					case 0:
						d = '签到';
						break;
					case 1:
						d = '已签到';
						break;
					case -9:
						d = '已请假';
						break;
					case -1:
						d = '本月无需签到';
						break;
					case -2:
						d = '无需签到';
						break;
				}
				return d;
			},
			setTimer() {
				this.timerFn = setInterval(() => {
					let d = new Date();
					let now = d.getTime()
					if (now >= this.startT && now <= this.endT) {
						this.status = 2
						this.statusName = '签到'
					} else if (now > this.endT) {
						this.status = 0
						this.statusName = '签到时间已过'
					} else if (now < this.startT) {
						this.status = 0
						this.statusName = '签到时间未到'
					}
					this.timer = d.getHours() + ':' + d.getMinutes() + ':' + d.getSeconds()
				}, 1000)
			},
			sign(t,s) {
				if (s != 0) {
					return
				}
				if (!this.flag) {
					return
				}
				this.flag = false;
				this.api.signSign({time:t}, this.id).then(res => {
					this.Toast('签到成功')
					// clearInterval(this.timerFn)
					this.flag = true;
					if(t == 'forenoon'){
						this.status = 1;
						this.statusName = '已签到'
					}else{
						this.status1 = 1;
						this.statusName1 = '已签到'
					}
					setTimeout(() => {
						window.history.go(-1)
					}, 1500)
				}).catch(() => {
					this.flag = true
				})
			}
		},
		created() {
			this.id = this.$route.query.id;
			this.getList()
			this.flag = true
		},
		destroyed() {
			clearInterval(this.timerFn)
		}
	}
</script>

<style scoped="scoped">
	.bc {
		width: 190px;
		height: 190px;
		border-radius: 50%;

	}

	.circle {
		width: 170px;
		height: 170px;
		color: #fff;
		border-radius: 50%;
		text-align: center;
		font-size: 25px;
	}

	.g {
		background-color: #B3F3F0;
	}

	.g .circle {
		background-color: #00D8CC;
	}

	.b {
		background-color: #C2E1FF;
	}

	.b .circle {
		background-color: #3399FF;
	}

	.h {
		background-color: #F0F0F0;
	}

	.h .circle {
		background-color: #ccc;
	}
</style>
